<template>
  <b-modal
    dialog-class="md-img-wrap"
    centered
    :no-close-on-backdrop="true"
    :hide-header="true"
    :hide-footer="true"
    content-class="md-img-con"
    body-class="md-img-body"
    id="gallery"
    :visible="visible"
    @show="onShow"
    @hide="hide"
  >
    <CCarousel
      v-model="currentSlide"
      cId="carousel-gallery"
      :interval="0"
      :indicators="false"
      cStyle="width: 100%;"
      @sliding-end="onSlideNext"
      ref="cCarousel"

      >
      <!--      @sliding-start="change_num"-->
      <b-carousel-slide
        v-for="image in src"
      >
        <template #img>
          <div style="display: flex; justify-content: center; width: 100%; height: 100vh;" >
            <img :src="image" :style="imageStyle"
            />
          </div>
        </template>
      </b-carousel-slide>

    </CCarousel>
    <div style="position: fixed; right: 1em; top:1em;z-index: 10000" @click="hide">
      <b-icon variant="white" font-scale="3" icon="x" ></b-icon>
    </div>
    <div style="position: fixed;" class="gallery-indicator">
      {{currentSlide + 1}}/{{src.length}}
    </div>
  </b-modal>
</template>

<script>
import CCarousel from "./CCarousel";
export default {
  name: "Gallery",
  components:{CCarousel},
  props:{
    src:{
      type:Array,
    },
    visible:{
      type:Boolean,
      default:false,
    },
    current: {
      type:Number,
      default: 0,
    }
  },
  data() {
    return {
      offset:0,
      imageStyle:"max-height: 100vh; max-width: 100vw;",
      currentSlide:0,
    }
  },
  methods:{
    hide(){
      this.$emit('update:visible', false);
    },
    ScrollZoom(container,max_scale,factor){

      var target = container.querySelector('.carousel-item.active img');
      var size = {w:target.clientWidth,h:target.clientHeight}
      var pos = {x:0,y:0}
      var zoom_target = {x:0,y:0}
      var zoom_point = {x:0,y:0}
      var scale = 1
      // target.setAttribute('style','transform-origin : 0 0');
      target.onwheel = scrolled;

      function scrolled(e){
        var offset = container.getBoundingClientRect();
        var target_offset = target.getBoundingClientRect();
        zoom_point.x = e.clientX - offset.left
        zoom_point.y = e.clientY - offset.top
        e.preventDefault();
        var delta = e.deltaY;
        if (delta === undefined) {
          //we are on firefox
          delta = e.originalEvent.detail;
        }
        delta = Math.max(-1,Math.min(1,delta)) // cap the delta to [-1,1] for cross browser consistency

        // determine the point on where the slide is zoomed in
        // zoom_target.x = (zoom_point.x - pos.x)/scale
        // zoom_target.y = (zoom_point.y - pos.y)/scale
        zoom_target.x = (offset.width/2 - zoom_point.x + pos.x)/scale;
        zoom_target.y = (offset.height/2 - zoom_point.y + pos.y)/scale;
        // apply zoom
        scale -= delta*factor * scale
        scale = Math.max(1,Math.min(max_scale,scale))

        // calculate x and y based on zoom
        // pos.x = -zoom_target.x * scale + zoom_point.x
        // pos.y = -zoom_target.y * scale + zoom_point.y
        pos.x = (scale - 1)*zoom_target.x;
        pos.y = (scale - 1)*zoom_target.y;


        // Make sure the slide stays in its container area when zooming out
        // if(pos.x>0)
        //   pos.x = 0
        // if(pos.x+size.w*scale<size.w)
        //   pos.x = -size.w*(scale-1)
        // if(pos.y>0)
        //   pos.y = 0
        // if(pos.y+size.h*scale<size.h)
        //   pos.y = -size.h*(scale-1)

        update()
      }

      function update(){
        target.setAttribute('style','transform:translate('+(pos.x)+'px,'+(pos.y)+'px) scale('+scale+','+scale+')');
      }
    },
    // change_num(num){
    //   this.current = num + 1;
    // }
    onShow(){
      let self = this;
      setTimeout(()=>{
        self.$refs.cCarousel.onMouseEnter();
      },200);
      this.currentSlide = this.current;
      this.onSlideNext();
    },
    onSlideNext(){
      var self = this;

      setTimeout(()=>{
        var el = document.getElementById('carousel-gallery');
        new self.ScrollZoom(el,4,0.5);
      },100);
    }

  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/controls/Gallery.vue